import { Component, OnInit } from '@angular/core';
import { ProjectService } from 'src/app/_services/project/project.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi, GridOptions, RowGroupingDisplayType } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { TimesheetService } from 'src/app/_services/timesheet/timesheet.service';
import { ActionItemsGridRowRendererComponent } from '../../../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { convertYYYYMMDDtoDDMMYYYY } from 'src/app/_helpers/utils';
import { ProjectStructureService } from 'src/app/_services/projectStructure/projectStructure.service';

@Component({
  selector: 'app-timesheetV2-report',
  templateUrl: './timesheetV2-report.component.html',
  styleUrls: ['./timesheetV2-report.component.scss']
})
export class TimesheetReportV2Component implements OnInit {

  tenantId: any;
  currentUser: any;
  reportForm: FormGroup;
  rowData: any;
  rowSelection: any;
  userDropdownList = [];
  isPMOManager: boolean = false;
  isPMOAdmin: boolean = false;
  isManagement: boolean = false;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = [];
  public columnDefs: ColDef[] = [];
  private api: GridApi;
  private columnApi: ColumnApi;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    sortable: true,
    resizable: true,
    wrapText: true,
  };
  public groupDisplayType: RowGroupingDisplayType = 'groupRows';
  modeAction: number = 1; //1 - create // 2 - update
  public selectedType: any = null;
  public employeeList: Array<any> = [];
  public projectTSList: Array<any> = [];
  public regionList: Array<any> = [];
  public industryList: Array<any> = [];
  public businessGroupList: Array<any> = [];
  public commodityList: Array<any> = [];
  public activityList: Array<any> = [];
  public projectSoftwareList: Array<any> = [];
  public taskList: Array<any> = [];
  public partList: Array<any> = [];
  public typeList: Array<any> = [
    {
      lable: 'Project',
      value: 'projectTS'
    },
    {
      lable: 'User',
      value: 'user'
    },
    {
      lable: 'Region',
      value: 'region'
    },
    {
      lable: 'Industry',
      value: 'industry'
    },
    {
      lable: 'Business Group',
      value: 'businessGroup'
    },
    {
      lable: 'Commodity',
      value: 'commodity'
    },
    {
      lable: 'Activity',
      value: 'activity'
    },
    {
      lable: 'Project Software',
      value: 'projectSoftware'
    },
    // {
    //   lable: 'Task List',
    //   value: 'task'
    // },
    // {
    //   lable: 'Part List',
    //   value: 'partList'
    // },
  ];

  constructor(
    private storageService: LocalStorageService,
    private timesheetService: TimesheetService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
    private projectService: ProjectService,
    private router: Router,
    private projectStructureService: ProjectStructureService
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent,
    };

  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isPMOAdmin = this.currentUser.roles.includes('RolePmoAdministrator');
    this.isManagement = this.currentUser.roles.includes('RoleAdministrator');
    this.isPMOManager = this.currentUser.roles.includes('RolePmoManager') || this.currentUser.roles.includes('RoleReportsExtractor');

    // REMOVE restricted types for non-admin users
    if (!(this.isPMOAdmin || this.isManagement)) {
      this.typeList = this.typeList.filter(type =>
        type.value !== 'region' &&
        type.value !== 'industry' &&
        type.value !== 'businessGroup' &&
        type.value !== 'commodity' &&
        type.value !== 'activity' &&
        type.value !== 'projectSoftware' && 
        type.value !== 'task' &&
        type.value !== 'partList'
      );
    }

    this.getUserList();
    this.getProjectList();
    this.getRegionList();
    this.getIndustryList();
    this.getBusinessGroupList();
    this.getCommodityList();
    this.getActivityList();
    this.getProjectSoftwareList();
    this.getTaskList();
    this.getPartList();


    this.reportForm = this.formBuilder.group({
      type: [null],
      ids: [null],
      startDate: [""],
      endDate: [""]
    });
  }

  backToTimesheet() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/timesheets/timesheetV2']);
  }

  timesheetNoPunch() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/timesheets/timesheetV2-noPunchReport']);
  }

  onGridReady(params: any) {
    this.rowData = [];
  }

  gridOptions: GridOptions = {
    groupIncludeFooter: true,
    groupIncludeTotalFooter: true,
  };

  public onSelectAll(type) {
    this.reportForm.get('ids').patchValue([]);
    switch (type) {
      case 'user':
        const selectedUser = this.employeeList.map(item => item.id);
        this.reportForm.get('ids').patchValue(selectedUser);
        break;
      case 'projectTS':
        const selectedProjectTS = this.projectTSList.map(item => item.id);
        this.reportForm.get('ids').patchValue(selectedProjectTS);
        break;
      case 'region':
        const selectedRegion = this.regionList.map(item => item.regionName);
        this.reportForm.get('ids').patchValue(selectedRegion);
        break;
      case 'industry':
        const selectedIndustry = this.industryList.map(item => item.industryName);
        this.reportForm.get('ids').patchValue(selectedIndustry);
        break;
      case 'businessGroup':
        const selectedBusinessGroup = this.businessGroupList.map(item => item.businessGroupName);
        this.reportForm.get('ids').patchValue(selectedBusinessGroup);
        break;
      case 'commodity':
        const selectedCommodity = this.commodityList.map(item => item.commodityName);
        this.reportForm.get('ids').patchValue(selectedCommodity);
        break;
      case 'activity':
        const selectedActivity = this.activityList.map(item => item.activityName);
        this.reportForm.get('ids').patchValue(selectedActivity);
        break;
      case 'projectSoftware':
        const selectedProjectSoftware = this.projectSoftwareList.map(item => item.projectSoftwareName);
        this.reportForm.get('ids').patchValue(selectedProjectSoftware);
        break;
      case 'task':
        const selectedTask = this.taskList.map(item => item.id);
        this.reportForm.get('ids').patchValue(selectedTask);
        break;
      case 'partList':
        const selectedPartList = this.partList.map(item => item.id);
        this.reportForm.get('ids').patchValue(selectedPartList);
        break;
      default:
        break;
    }
  }

  public onClearAll() {
    this.reportForm.get('ids').patchValue([]);
  }

  getUserList() {
    this.employeeList = [];
    this.timesheetService.getTimesheetReportsUser(this.currentUser.id).subscribe((users : any) => {
      this.employeeList = users.map(u => ({
        id: u.id,
        name: `${u.id} . ${u.firstName} ${u.lastName}`
      }));
    });
  }

  getProjectList() {
    if (this.isPMOAdmin === true) {
      this.projectService.getAllRootProjectV2().subscribe((response: any) => {
        this.projectTSList = response;
      });
    }
    else { // if(this.isPMOManager === true)
      this.projectService.getAllProjectV2ByUserId(this.currentUser.id).subscribe((response: any) => {
        this.projectTSList = response;
      });
    }
  }

  getRegionList() {
    this.regionList = [];
    this.projectStructureService.getRegion().subscribe((response: any) => {
      const uniqueRegions = Array.from(
        new Map(response.map(res => [res.regionName, res])).values()
      );

      this.regionList = uniqueRegions.map((res: any) => ({
        id: res.id,
        regionName: `${res.regionName}`
      }));
    });
  }

  getIndustryList() {
    this.industryList = [];
    this.projectStructureService.getIndustry().subscribe((response: any) => {
      const uniqueIndustry = Array.from(
        new Map(response.map(res => [res.industryName, res])).values()
      );

      this.industryList = uniqueIndustry.map((res: any) => ({
        id: res.id,
        industryName: `${res.industryName}`
      }));
    });
  }

  getBusinessGroupList() {
    this.businessGroupList = [];
    this.projectStructureService.getBusinessGroup().subscribe((response: any) => {
      this.businessGroupList = response.map(res => ({
        id: res.id,
        businessGroupName: `${res.businessGroupName}`
      }));
    });
  }

  getCommodityList() {
    this.commodityList = [];
    this.projectStructureService.getCommodity().subscribe((response: any) => {
      this.commodityList = response.map(res => ({
        id: res.id,
        commodityName: `${res.commodityName}`
      }));
    });
  }

  getActivityList() {
    this.activityList = [];
    this.projectStructureService.getActivity().subscribe((response: any) => {
      this.activityList = response.map(res => ({
        id: res.id,
        activityName: `${res.activityName}`
      }));
    });
  }

  getProjectSoftwareList() {
    this.projectSoftwareList = [];
    this.projectStructureService.getProjectSoftware().subscribe((response: any) => {
      this.projectSoftwareList = response.map(res => ({
        id: res.id,
        projectSoftwareName: `${res.projectSoftwareName}`
      }));
    });
  }

  getTaskList() {
    this.taskList = [];
    this.projectStructureService.getTaskDropdown().subscribe((response: any) => {
      this.taskList = response.map(res => ({
        id: res.id,
        taskDropdownName: `${res.id} . ${res.taskDropdownName}`
      }));
    });
  }

  getPartList() {}

  onchangeType() {
    this.reportForm.patchValue({
      ids: []
    });
  }

  generateReport() {
    this.columnDefs = [];
    const { startDate, endDate, ids } = this.reportForm.value;
    let type = this.reportForm.value.type ? this.reportForm.value.type : '';
    let formattedStartDate = startDate ? convertYYYYMMDDtoDDMMYYYY(startDate) : '';
    let formattedEndDate = endDate ? convertYYYYMMDDtoDDMMYYYY(endDate) : '';
    let formattedIds = ids && ids.length > 0 ? ids.join(',') : "";
    let queryParams : any;
    if( type === 'projectTS' || type === 'user' || type === 'task'){
      queryParams = `type=${type}&startDate=${formattedStartDate}&endDate=${formattedEndDate}&ids=${encodeURIComponent(formattedIds)}`;
    }
    else if( type === 'region' || type === 'industry' || type === 'businessGroup' || type === 'commodity' || type === 'activity' || type === 'projectSoftware') {
      queryParams = `type=${type}&startDate=${formattedStartDate}&endDate=${formattedEndDate}&typeValue=${encodeURIComponent(formattedIds)}`;
    }
    

    this.timesheetService.getTimesheetV2Report(queryParams).subscribe((res => {
      if (res) {
        this.setColumnDefinitions(type);
        this.setRowData(type, res);
      }
    }));
  }

  setColumnDefinitions(type) {
    if (type === 'user') {
      this.columnDefs = this.getUserColumnDefs();
    } else if (type === 'projectTS') {
      this.columnDefs = this.getProjectTSColumnDefs();
    } else if (type === 'region') {
      this.columnDefs = this.getRegionColumnDefs();
    } else if (type === 'industry') {
      this.columnDefs = this.getIndustryColumnDefs();
    } else if (type === 'businessGroup') {
      this.columnDefs = this.getBusinessGroupColumnDefs();
    } else if (type === 'commodity') {
      this.columnDefs = this.getCommodityColumnDefs();
    } else if (type === 'activity') {
      this.columnDefs = this.getActivityColumnDefs();
    } else if (type === 'projectSoftware') {
      this.columnDefs = this.getProjectSoftwareColumnDefs();
    }
    // else if (type === 'task') {
    //   this.columnDefs = this.getTaskColumnDefs();
    // } else if (type === 'partList') {
    //   this.columnDefs = this.getPartListColumnDefs();
    // }
  }

  setRowData(type: string, res: any) {
    if (type === 'user') {
      this.rowData = this.processUserData(res);
    } else if (type === 'projectTS') {
      this.rowData = this.processProjectTSData(res);
    } else if (type === 'region') {
      this.rowData = this.processProductStructureData(res);
    } else if (type === 'industry') {
      this.rowData = this.processProductStructureData(res);
    } else if (type === 'businessGroup') {
      this.rowData = this.processProductStructureData(res);
    } else if (type === 'commodity') {
      this.rowData = this.processProductStructureData(res);
    } else if (type === 'activity') {
      this.rowData = this.processProductStructureData(res);
    } else if (type === 'projectSoftware') {
      this.rowData = this.processProductStructureData(res);
    }
    // else if (type === 'task') {
    //   this.rowData = this.processTaskData(res);
    // } else if (type === 'partList') {
    //   this.rowData = this.processPartListData(res);
    // }
  }

//User Based Report
  getUserColumnDefs(): ColDef[] {
    return [
      { field: 'userName', rowGroup: true, hide: true },
      { field: 'userName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', minWidth: 200 },
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Employee Total';
            return '';
          }

          return params.data?.taskName ?? '';
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 250, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Activity', field: 'activityName' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) { return firstRow.userTotalAppliedHours ?? ''; }
            return '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.userTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) { return firstRow.userEfficiency ?? ''; }
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

  processUserData(res: any): any[] {
    const userArray: Array<any> = [];
    let users = res['users'];

    if (users && users.length > 0) {
      for (let i = 0; i < users.length; i++) {
        let projects = users[i]['projects'];
        if (projects && projects.length > 0) {
          for (let index = 0; index < projects.length; index++) {
            let timesheets = projects[index]['timesheets'];
            if (timesheets && timesheets.length > 0) {
              for (let j = 0; j < timesheets.length; j++) {
                userArray.push({
                  userName: users[i].userName,
                  projectName: timesheets[j].projectV2Name,
                  taskName: timesheets[j].projectV2TaskName,
                  description: timesheets[j].description,
                  regionName: timesheets[j].regionName,
                  industryName: timesheets[j].industryName,
                  businessGroup: timesheets[j].businessGroup,
                  commodity: timesheets[j].commodity,
                  partList: timesheets[j].partList,
                  activityName: timesheets[j].activityName,
                  projectSoftwareName: timesheets[j].projectSoftwareName,
                  startDate: timesheets[j].startDate,
                  endDate: timesheets[j].endDate,
                  appliedHours: timesheets[j].totalHours,
                  approvedHours: timesheets[j].approvedHours,
                  efficiency: timesheets[j].efficiency,
                  userTotalAppliedHours: users[i].totalHours,
                  userTotalApprovedHours: users[i].approvedHours,
                  userEfficiency: users[i].efficiency,
                });
              }
            }
          }
        }
      }
    }
    return userArray;
  }

//Project Based Report
  getProjectTSColumnDefs(): ColDef[] {
    return [
      { field: 'projectName', rowGroup: true, hide: true },
      { field: 'projectName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Activity', field: 'activityName' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.projectEfficiency ?? ''
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

  processProjectTSData(res: any): any[] {
    let projectTSArray: Array<any> = [];
    let projects = res['projects'];

    if (projects && projects.length > 0) {
      for (let i = 0; i < projects.length; i++) {
        let users = projects[i]['users'];
        if (users && users.length > 0) {
          for (let index = 0; index < users.length; index++) {
            let timesheets = users[index]['timesheets'];
            if (timesheets && timesheets.length > 0) {
              for (let j = 0; j < timesheets.length; j++) {
                projectTSArray.push({
                  projectName: projects[i].projectName,
                  projectId: projects[i].projectId,
                  userName: users[index].userName,
                  taskName: timesheets[j].projectV2TaskName,
                  description: timesheets[j].description,
                  regionName: timesheets[j].regionName,
                  industryName: timesheets[j].industryName,
                  businessGroup: timesheets[j].businessGroup,
                  commodity: timesheets[j].commodity,
                  partList: timesheets[j].partList,
                  activityName: timesheets[j].activityName,
                  projectSoftwareName: timesheets[j].projectSoftwareName,
                  startDate: timesheets[j].startDate,
                  endDate: timesheets[j].endDate,
                  appliedHours: timesheets[j].totalHours,
                  approvedHours: timesheets[j].approvedHours,
                  efficiency: timesheets[j].efficiency,
                  projectTotalAppliedHours: projects[i].totalHours,
                  projectTotalApprovedHours: projects[i].approvedHours,
                  projectEfficiency: projects[i].efficiency,
                });
              }
            }
          }
        }
      }
    }
    return projectTSArray;
  }

//Region Data
  getRegionColumnDefs(): ColDef[] {
    return [
      { headerName: 'Region', field: 'typeName', rowGroup: true, hide: true },
      { headerName: 'Region', field: 'typeName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', rowGroup: true, hide: true },
      { field: 'projectName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Region Total';
            if (params.node.level === 1) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Activity', field: 'activityName' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.typeTotalApprovedHours ?? '';
            if (params.node.level === 1) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeEfficiency ?? ''
            if (params.node.level === 1) return firstRow?.projectEfficiency ?? ''
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

//Industry
  getIndustryColumnDefs(): ColDef[] {
    return [
      { headerName: 'Industry', field: 'industryName', rowGroup: true, hide: true },
      { headerName: 'Industry', field: 'industryName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', rowGroup: true, hide: true },
      { field: 'projectName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Industry Total';
            if (params.node.level === 1) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Activity', field: 'activityName' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.typeTotalApprovedHours ?? '';
            if (params.node.level === 1) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeEfficiency ?? '';
            if (params.node.level === 1) return firstRow?.projectEfficiency ?? ''
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

//Business Group Data
  getBusinessGroupColumnDefs(): ColDef[] {
    return [
      { headerName: 'Business Group', field: 'businessGroup', rowGroup: true, hide: true },
      { headerName: 'Business Group', field: 'businessGroup', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', rowGroup: true, hide: true },
      { field: 'projectName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Business Group Total';
            if (params.node.level === 1) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Activity', field: 'activityName' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.typeTotalApprovedHours ?? '';
            if (params.node.level === 1) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeEfficiency ?? '';
            if (params.node.level === 1) return firstRow?.projectEfficiency ?? '';
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

//Commodity
  getCommodityColumnDefs(): ColDef[] {
    return [
      { headerName: 'Commodity', field: 'commodity', rowGroup: true, hide: true },
      { headerName: 'Commodity', field: 'commodity', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', rowGroup: true, hide: true },
      { field: 'projectName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Commodity Total';
            if (params.node.level === 1) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Activity', field: 'activityName' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.typeTotalApprovedHours ?? '';
            if (params.node.level === 1) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeEfficiency ?? '';
            if (params.node.level === 1) return firstRow?.projectEfficiency ?? ''
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

//Activity Data
  getActivityColumnDefs(): ColDef[] {
    return [
      { headerName: 'Activity', field: 'activityName', rowGroup: true, hide: true },
      { headerName: 'Activity', field: 'activityName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', rowGroup: true, hide: true },
      { field: 'projectName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Activity Total';
            if (params.node.level === 1) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.typeTotalApprovedHours ?? '';
            if (params.node.level === 1) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeEfficiency ?? '';
            if (params.node.level === 1) return firstRow?.projectEfficiency ?? ''
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

//Project Software
  getProjectSoftwareColumnDefs(): ColDef[] {
    return [
      { headerName: 'Project Software', field: 'projectSoftwareName', rowGroup: true, hide: true },
      { headerName: 'Project Software', field: 'projectSoftwareName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', rowGroup: true, hide: true },
      { field: 'projectName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Project Software Total';
            if (params.node.level === 1) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Activity', field: 'activityName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.typeTotalApprovedHours ?? '';
            if (params.node.level === 1) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeEfficiency ?? '';
            if (params.node.level === 1) return firstRow?.projectEfficiency ?? ''
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

//Task Data
  getTaskColumnDefs(): ColDef[] {
    return [
      { headerName: 'Task Name', field: 'taskDropdownName', rowGroup: true, hide: true },
      { headerName: 'Task Name', field: 'taskDropdownName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', rowGroup: true, hide: true },
      { field: 'projectName', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Task Total';
            if (params.node.level === 1) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Part List', field: 'partList' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Activity', field: 'activityName' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.typeTotalApprovedHours ?? '';
            if (params.node.level === 1) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeEfficiency ?? '';
            if (params.node.level === 1) return firstRow?.projectEfficiency ?? ''
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

//Part List
  getPartListColumnDefs(): ColDef[] {
    return [
      { headerName: 'Part List', field: 'partList', rowGroup: true, hide: true },
      { headerName: 'Part List', field: 'partList', minWidth: 200, cellRenderer: 'agGroupCellRenderer' },
      { field: 'projectName', minWidth: 200},
      { field: 'userName', minWidth: 200},
      { field: 'taskName', minWidth: 200, tooltipField: 'taskName',
        valueGetter: (params) => {
          if (params.node.footer) {
            if (params.node.level === 0) return 'Part List Total';
            if (params.node.level === 1) return 'Project Total';
            return '';
          }
          return params.data?.taskName ?? ''; 
        },
      },
      { headerName: 'Timesheet Description', field: 'description', minWidth: 200, tooltipField: 'description', },
      { headerName: 'Region', field: 'regionName' },
      { headerName: 'Industry', field: 'industryName' },
      { headerName: 'Business Group', field: 'businessGroup' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'Activity', field: 'activityName' },
      { headerName: 'Project Software', field: 'projectSoftwareName' },
      { field: 'startDate' },
      { field: 'endDate' },
      { field: 'appliedHours',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return firstRow?.projectTotalAppliedHours ?? '';
          }
          return params.data?.appliedHours ?? '';
        }
      },
      { field: 'approvedHours',
        valueGetter: params => {
          if (params.node.footer) {
            const row = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return row?.typeTotalAppliedHours ?? '';
            if (params.node.level === 1) return row?.projectTotalApprovedHours ?? '';
          }
          return params.data?.approvedHours ?? '';
        }
      },
      { field: 'efficiency',
        valueGetter: (params) => {
          if (params.node.footer) {
            const firstRow = params.node.allLeafChildren?.[0]?.data;
            if (params.node.level === 0) return firstRow?.typeEfficiency ?? '';
            if (params.node.level === 1) return firstRow?.projectEfficiency ?? '';
          }
          return params.data?.efficiency ?? '';
        }
      },
    ];
  }

  processProductStructureData(res: any): any[] {
    let productStructureArray: Array<any> = [];

    if (res && res.length > 0) {
      for (let r = 0; r < res.length; r++) {
        let type = res[r];
        let value = type?.value;
        let projects = value?.projects;

        if (projects && projects.length > 0) {
          for (let i = 0; i < projects.length; i++) {
            let users = projects[i]['users'];
            if (users && users.length > 0) {
              for (let index = 0; index < users.length; index++) {
                let timesheets = users[index]['timesheets'];
                if (timesheets && timesheets.length > 0) {
                  for (let j = 0; j < timesheets.length; j++) {
                    productStructureArray.push({
                      typeName: type?.typeName,
                      projectName: projects[i].projectName,
                      projectId: projects[i].projectId,
                      userName: users[index].userName,
                      taskName: timesheets[j].projectV2TaskName,
                      description: timesheets[j].description,
                      regionName: timesheets[j].regionName,
                      industryName: timesheets[j].industryName,
                      businessGroup: timesheets[j].businessGroup,
                      commodity: timesheets[j].commodity,
                      partList: timesheets[j].partList,
                      activityName: timesheets[j].activityName,
                      projectSoftwareName: timesheets[j].projectSoftwareName,
                      startDate: timesheets[j].startDate,
                      endDate: timesheets[j].endDate,
                      appliedHours: timesheets[j].totalHours,
                      approvedHours: timesheets[j].approvedHours,
                      efficiency: timesheets[j].efficiency,
                      typeTotalAppliedHours: value.totalHours,
                      typeTotalApprovedHours: value.approvedHours,
                      typeEfficiency: value.efficiency,
                      projectTotalAppliedHours: projects[i].totalHours,
                      projectTotalApprovedHours: projects[i].approvedHours,
                      projectEfficiency: projects[i].efficiency,
                    });
                  }
                }
              }
            }
          }
        }
      }
    }

    return productStructureArray;
  }

}
